import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../../components/button/Button';
import ModalType from '../../../models/ModalType';

import { InsurancesCarousel } from '../../../components/insurancesCarousel/InsurancesCarousel';
import { useModal } from '../../../context/ModalContext';

import './insurancesSection.scss';

export default function InsurancesSection(props) {
  const { pretitle, title, subtitle } = props;

  const { openModal } = useModal();

  return (
    <section id="insurances" className="insurance">
      <div className="title-container">
        <p className="overline salmon">{pretitle}</p>
        <h2>{parse(title)}</h2>
        <h6>{subtitle}</h6>
      </div>

      <InsurancesCarousel />

      <Button
        text="Are you eligible?"
        displayArrow
        dataAttr="CTA_clicked_insurance"
        onClick={() => {
          if (window.posthog) window.posthog.capture('eligibility_check_clicked');
          openModal(ModalType.CHECK_ELIGIBILITY);
        }}
        className="blue"
      />
    </section>
  );
}

InsurancesSection.propTypes = {
  pretitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
